import { Field, reduxForm } from 'redux-form'
import React, { Component, PropTypes } from 'react';
import { getTeacherSubjects, updateTeacherProfile } from '../teacher_action';
import { input, textarea } from '../../library/elements';

import Select from 'react-select';
import { connect } from 'react-redux';
import { normalizeField } from '../../library/function';

class UpdateProfile extends Component {

  constructor(props) {
    super(props);
    this.handleProfileSubmit = this.handleProfileSubmit.bind(this);
    this.removeModal = this.handleProfileSubmit.bind(this);
    this.state = {
      isLoading: false,
      isPasswordText: false,
      isPasswordConfirmText: false
    };
  }
  componentDidMount() {
    this.props.getTeacherSubjects();
  }

  handleProfileSubmit(formProps) {
    this.state = { isLoading: true };
    var _this = this;
 
    const data = new FormData();
    var image = formProps.image;
    //delete formProps.image;
    formProps.subjectList = formProps?.subjects?.length > 0 ? formProps.subjects.split(',') : [];
  
    data.append('name', formProps.name);
    data.append('phoneNumber', formProps.phoneNumber);
    data.append('address', formProps.address);
    data.append('subjectList', formProps.subjectList);
    data.append('age', formProps.age);
    if (image) {
      data.append('media', image[0]);
    }
  
    this.props.updateTeacherProfile(data, function (err, result) {
      if (result) {
        _this.props.removeModal();
        this.state = { isLoading: false };
      }
    });
  }
  closeModal() {
    this.props.removeModal();
  }



  addDefaultSrc(ev) {
    return ev.target.src = 'profile/User-default-image-boy.png';
  }

  renderPasswordMask(getState) {
    if (this.state[getState] == false) {
      this.setState({ [getState]: true });
    } else {
      this.setState({ [getState]: false });
    }
  }
  renderConfirmPasswordMask(getState) {
    if (this.state[getState] == false) {
      this.setState({ [getState]: true });
    } else {
      this.setState({ [getState]: false });
    }
  }

  render() {
    const { handleSubmit, errorMessage, teacher_subject_list } = this.props;
    var { isLoading, isPasswordText, isPasswordConfirmText } = this.state;
    if (errorMessage) {
      isLoading = false;
    }
    var subjectData = [];
    for (var i in teacher_subject_list) {
      subjectData.push({ label: teacher_subject_list[i].name, value: teacher_subject_list[i]._id });
    }
    return (
      <div className="profile-modal model-card cm-frm">
        <form onSubmit={handleSubmit(this.handleProfileSubmit.bind(this))} className="df-form">
          {
            errorMessage
              ?
              <fieldset className="form-group">
                <div className="col-sm-12 card-body">
                  <div className="alert alert-danger">
                    {errorMessage}
                  </div>
                </div>
              </fieldset>
              :
              null
          }

          <div className="card-block p-1">
            <div className="form-group row">
              <div className="col-sm-12 text-left">
                <Field name="image" component={image => {
                  var showImage = null;
                  if (image.input.value && image.input.value !== '') {
                    showImage = (
                      <div className="pro-image">
                        <img onError={this.addDefaultSrc} src={image.input.value.dataUrl ? image.input.value.dataUrl : image.input.value} className='m-l-10' width='100' height='100' />
                        <div className="fileUpload md-btn btn btn-primary">
                          <span>Upload Profile Image</span>
                          <input type="file"
                            name="image"
                            className="ml-2"
                            onChange={(e) => {
                              var files = e.target.files;
                              let reader = new FileReader();
                              let file = e.target.files[0];
                              reader.onload = function (e) {
                                var picFile = e.target;
                                files.dataUrl = picFile.result;
                                image.input.onChange(files);
                              }
                              reader.readAsDataURL(file);
                            }} />
                        </div>
                      </div>
                    )
                  }
                  return (
                    <div>
                      {
                        showImage !== null
                          ?
                          showImage
                          :
                          <div className="fileUpload md-btn btn btn-primary">
                            <span>Upload Profile Image</span>
                            <input type="file"
                              name="image"
                              className="m-l-20"
                              onChange={(e) => {
                                var files = e.target.files;
                                let reader = new FileReader();
                                let file = e.target.files[0];
                                reader.onload = function (e) {
                                  var picFile = e.target;
                                  files.dataUrl = picFile.result;
                                  image.input.onChange(files);
                                }
                                reader.readAsDataURL(file);
                              }} /> </div>}

                    </div>)
                }
                } />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-sm-12">
                <Field name="name" type="text" component={input} label="Name" className="form-control" />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 form-group">
                <Field name="age" type="text" component={input} label="Age" className="form-control" />
              </div>
              <div className="col-sm-6">
                <Field name="phoneNumber" type="text" component={input} label="Phone Number" className="form-control" />
              </div>
            </div>
            <div className="form-group row">

              <div className="col-sm-12">
                <Field name="address" row="" component={textarea} label="Address" isRequired={true} is_label={true} className="form-control" />
              </div>
            </div>

            
              <div className="form-group row">
                <div className="col-sm-12 ">
                <Field name="subjects" component={subjects => {
                return (
                  <Select multi simpleValue
                    value={subjects.input.value}
                    placeholder="Select Subject"
                    options={subjectData}
                    onChange={(e) => {
                      subjects.input.onChange(e);

                    }} />

                )

              }} className="form-control" />
                </div>

              </div>

              <div className="row">
                <div className="col-sm-9">
                  <button action="updateprofile" type="submit" disabled={isLoading} className="md-btn btn btn btn-primary btn-block mb-1">
                    <i className="fa fa-pencil-circle"></i> {isLoading ? 'Loading...' : 'Update'}
                  </button>
                </div>
                <div className="col-sm-3">
                  <button onClick={() => this.closeModal()} type="button" className="md-btn btn btn-danger btn-block">Cancel</button>
                </div>

              </div>

            </div>
        </form>
      </div>
    );
  }
}

function validate(formProps) {
  const errors = {}
  if (!formProps.name) {
          errors.name = 'Required Name';
  }

  if (!formProps.age) {
          errors.age = 'Required Age';
  } else {
    if (isNaN(formProps.age)) {
          errors.age = 'Age must be numeric only!';
    }
  }

  if (!formProps.phoneNumber) {
          errors.phoneNumber = 'Required Phone Number';
  } else {
    if (isNaN(formProps.phoneNumber)) {
          errors.phoneNumber = 'Phone Number number must be numeric only!';
    } else if (formProps.phoneNumber.length > 10) {
          errors.phoneNumber = 'Phone Number number must be up to 10 digit!';
    }
  }



  return errors;
}

function mapStateToProps(state) {
  var iniCus = {};
  if (state.teacher.teacher_profile) {
          iniCus = state.teacher.teacher_profile;
    iniCus.image = state.teacher.teacher_profile.customer_image;
    var subjectData = [];
    for (var i in iniCus.subjectList) {
      subjectData.push(iniCus.subjectList[i]._id);
    }
    var stringValueYouWant = subjectData.join(',');
    iniCus.subjects = stringValueYouWant;
  }
  
  return {
    initialValues: iniCus,
    errorMessage: state.account.error,
    teacher_subject_list: state.teacher.teacher_subject_list,
  }
}

UpdateProfile = reduxForm({
          form: 'updateprofile',
  validate: validate
})(UpdateProfile);

export default connect(mapStateToProps, { updateTeacherProfile, getTeacherSubjects})(UpdateProfile);
